

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
          <div>
            <h3 className="text-white text-xl font-bold mb-4">PrimeChart</h3>
            <p className="text-sm leading-relaxed">
              Connecting patients with top medical professionals to provide
              quality healthcare services.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { name: "Home", path: "/" },
                { name: "Specializations", path: "/specializations" },
                { name: "Find Doctor", path: "/find-doctor" },
                { name: "Booking Guide", path: "/booking-guide" },
              ].map((link) => (
                <li key={link.name}>
                  <a
                    href={link.path}
                    className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 mt-10 pt-6 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} primeChart. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
